import diamondIcon from "@/assets/icons/ui/vip-diamond.png";
import Image from "next/image";
import { twMerge } from "tailwind-merge";

export function UpgradeTip({ className }: { className?: string }) {
  return (
    <span
      className={twMerge(
        "flex items-center gap-1 text-xs bg-[rgba(82,81,246,0.15)] text-text-secondary rounded-sm px-1.5 py-0.5",
        className
      )}
    >
      <Image src={diamondIcon} alt="" width={10} height={10} />
      Upgrade
    </span>
  );
}
